import { postAnalyticsEvent } from './common';

const EVENT_TYPES = {
  QUICK_REPLY_SELECTED: 'QUICK_REPLY_SELECTED',
  QUICK_REPLY_FETCHED: 'QUICK_REPLY_FETCHED',
  QUICK_REPLY_DISPLAYED: 'QUICK_REPLY_DISPLAYED',
};

export const trackQuickReplySelected = async (ticket, params) => {
  const parsePointers = {
    conversationPtr: ticket.ticketId,
    simplrAccountPtr: ticket.simplrAccountPtrId,
    simplrExpertPtr: ticket.expertId,
  };

  return await postAnalyticsEvent(EVENT_TYPES.QUICK_REPLY_SELECTED, parsePointers, params);
};

export const trackQuickReplyFetched = async (ticket, params) => {
  const parsePointers = {
    conversationPtr: ticket.ticketId,
    simplrAccountPtr: ticket.simplrAccountPtrId,
    simplrExpertPtr: ticket.expertId,
  };

  return await postAnalyticsEvent(EVENT_TYPES.QUICK_REPLY_FETCHED, parsePointers, params);
};

export const trackQuickReplyDisplayed = async (ticket, params) => {
  const parsePointers = {
    conversationPtr: ticket.ticketId,
    simplrAccountPtr: ticket.simplrAccountPtrId,
    simplrExpertPtr: ticket.expertId,
  };

  return await postAnalyticsEvent(EVENT_TYPES.QUICK_REPLY_DISPLAYED, parsePointers, params);
};
